export const BOARD_URL_FORM_EXTERNAL_LINK_LABEL = 'Lien externe';
